"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_RESULT_KINDS = exports.zSearchQuery = void 0;
const zod_1 = require("zod");
exports.zSearchQuery = zod_1.z.object({ q: zod_1.z.string().trim().min(1) });
exports.SEARCH_RESULT_KINDS = ["customer", "vehicle", "work_order", "invoice", "technician"];
//# sourceMappingURL=search.js.map